// Local Development
// const API_ENDPOINT = "http://localhost:5000";
// Production
const API_ENDPOINT = "https://bgent.fly.dev/api";
// const API_ENDPOINT = "https://0.0.0.0:8080/api";
export default API_ENDPOINT;